import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import React, { forwardRef } from "react";
import CanvasDraw from "react-canvas-draw";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: "center",
		color: theme.palette.text.secondary,
	},
}));

const Drawing = forwardRef((props, ref) => {
	const signCanvas = React.createRef();
	const classes = useStyles();

	const [imageBase64, setImageBase64] = React.useState();
	const [myCanvas, setMyCanvas] = React.useState();

	const defaultProps = {
		//		onChange: handleOnChange,
		//loadTimeOffset: 5,
		//lazyRadius: 30,
		brushRadius: 3,
		//brushColor: "#444",
		//catenaryColor: "#0a0302",
		gridColor: "rgba(150,150,150,0.17)",
		//hideGrid: true,
		canvasWidth: 400,
		canvasHeight: 200,
		//disabled: false,
		//imgSrc: "",
		//saveData: ()=>console.log(getSaveData),
		//immediateLoading: false,
		//hideInterface: false,
	};
	const handleOnChange = (e) => {
		console.log("Drawing e=", e);
		createSignImg(e);
	};
	const getImagesaved = () => {
		//console.log("Drawing loadSaveData=", loadSaveData());
	};
	const createSignImg = async (refconv) => {
		const signImg = refconv.canvas.drawing.toDataURL("image/png");
		console.log("signImg =", signImg);
		setImageBase64(signImg);
		props.handleChange(signImg);
	};

	return (
		<div>
			<Grid container spacing={3}>
				<Grid item xs={8}>
					<Paper className={classes.paper}>
						Sign Here
						<CanvasDraw
							ref={(canvasDraw) => setMyCanvas(canvasDraw)}
							onChange={handleOnChange}
							canvasWidth={350}
							canvasHeight={300}
							lazyRadius={5}
							//saveData={initialData}
						/>
						<button
							onClick={() => {
								myCanvas.clear();
								setImageBase64(null);
								props.handleChange(null);
							}}
						>
							Clear
						</button>
						<button
							onClick={() => {
								myCanvas.undo();
							}}
						>
							Undo
						</button>
					</Paper>
				</Grid>
				<Grid item xs={4}>
					<Paper className={classes.paper}>
						<div style={{ width: "100%", height: "100%" }}>
							{imageBase64 && (
								<>
									<img src={imageBase64} style={{ width: 180, height: 100 }} />
									Document Signed by
								</>
							)}
						</div>
					</Paper>
				</Grid>
			</Grid>
		</div>
	);
});

export default Drawing;
